<div id="feature" class="feature mt-3">
  <p class="d-block text-center  text-dark fw-semibold font-20" translate>feature_title</p>
  <!-- <div class="bg-white py-3 d-none d-sm-block">
        <owl-carousel-o [options]="slideOption" dir="ltr"  >
            <ng-template carouselSlide >
                <div class="marquee" >
                    <div class="track">
                      <div class="content d-sm-flex justify-items-between align-items-center">
                        <div class="px-lg-3 px-3 item-wrap  wx-275" *ngFor="let item of items">
                            <img [src]=item.img class="img-fluid px-lg-0 wx-275" alt="">
                          </div>
                      </div>
                    </div>
                  </div>
            </ng-template>
            
        </owl-carousel-o> 
      
    </div> -->
  <div class="crs-div d-none d-sm-block">
    <div class="marquee pb-4 d-none d-sm-block">
      <div class="marquee-content">
        <div class="marquee-item">
          <img src="/assets/images/featured/logo (1).svg" alt="">
        </div>

        <div class="marquee-item ">
          <img src="/assets/images/featured/logo (2).svg" alt="">
        </div>

        <div class="marquee-item">
          <img src="/assets/images/featured/logo (3).svg" alt="">
        </div>

        <div class="marquee-item">
          <img src="/assets/images/featured/logo (4).svg" alt="">
        </div>

        <div class="marquee-item">
          <img src="/assets/images/featured/logo (5).svg" alt="">
        </div>

        <div class="marquee-item">
          <img src="/assets/images/featured/logo (6).svg" alt="">
        </div>

        <div class="marquee-item">
          <img src="/assets/images/featured/logo (7).svg" alt="">
        </div>

        <div class="marquee-item">
          <img src="/assets/images/featured/logo (1).svg" alt="">
        </div>



        <div class="marquee-item">
          <img src="/assets/images/featured/logo (2).svg" alt="">
        </div>

        <div class="marquee-item">
          <img src="/assets/images/featured/logo (3).svg" alt="">
        </div>

        <div class="marquee-item">
          <img src="/assets/images/featured/logo (4).svg" alt="">
        </div>

        <div class="marquee-item">
          <img src="/assets/images/featured/logo (5).svg" alt="">
        </div>

        <div class="marquee-item">
          <img src="/assets/images/featured/logo (6).svg" alt="">
        </div>

        <div class="marquee-item">
          <img src="/assets/images/featured/logo (7).svg" alt="">
        </div>

        <div class="marquee-item">
          <img src="/assets/images/featured/logo (1).svg" alt="">
        </div>

      </div>
    </div>
  </div>


  <div class="marquee d-block d-sm-none">
    <div class="track">
      <div class="content d-flex justify-items-between align-items-center">
        <div class="px-3" *ngFor="let item of items">
          <img [src]=item.img class="img-fluid " alt="">
        </div>
        <div class="px-3" *ngFor="let item of items">
          <img [src]=item.img class="img-fluid " alt="">
        </div>
      </div>
    </div>
  </div>

</div>